import AppColors from 'general/constants/AppColors';
import UIHelper from 'general/helpers/UIHelper';
import PropTypes from 'prop-types';

WizardStep.propTypes = {
  fill: PropTypes.bool,
  step: PropTypes.number,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  done: PropTypes.bool,
  active: PropTypes.bool,
  direction: PropTypes.oneOf(['horizontal', 'vertical']),
  currentStep: PropTypes.number,
  isLast: PropTypes.bool,
};

function WizardStep(props) {
  const { step, title, subTitle, done, active, fill = false, direction = 'horizontal', currentStep = 1, isLast = false } = props;

  const isVertical = direction === 'vertical';

  if (isVertical) {
    return (
      <div className="d-flex align-items-start gap-4 position-relative">
        {!isLast && (
          <div
            style={{
              position: 'absolute',
              left: '15px',
              top: '30px',
              bottom: '-20px',
              width: '2px',
              backgroundImage: `linear-gradient(to bottom, ${done
                ? currentStep > step + 1
                  ? AppColors.primary
                  : AppColors.warning
                : AppColors.gray[300]
                } 50%, transparent 50%)`,
              backgroundSize: '100% 8px',
              backgroundRepeat: 'repeat-y',
              pointerEvents: 'none',
            }}
          />
        )}

        <div
          className="w-30px h-30px rounded-circle flex-shrink-0"
          style={{
            padding: '3px',
            backgroundColor: done
              ? AppColors.primary
              : '#fff',
            border: `3px solid ${done ? AppColors.primary : active ? AppColors.warning : AppColors.gray[400]}`
          }}
        >
          <div
            className="rounded-circle d-flex justify-content-center align-items-center w-100 h-100"
          >
            {done ? (
              <i className="fa-regular fa-check text-white" />
            ) : (
              <span
                style={UIHelper.buildFontStyle(
                  '600',
                  '14px',
                  active ? AppColors.warning : AppColors.gray[400]
                )}
              >
                {step}
              </span>
            )}
          </div>
        </div>

        <div className="d-flex flex-column pb-5">
          <span
            style={UIHelper.buildFontStyle(
              '500',
              '14px',
              done ? AppColors.primary : active ? AppColors.warning : AppColors.gray[600]
            )}
          >
            {title}
          </span>
          <span
            style={UIHelper.buildFontStyle(
              '500',
              '16px',
              AppColors.gray[800]
            )}
          >
            {subTitle}
          </span>
        </div>
      </div>
    );
  }

  return (
    <div
      className={`mr-4 py-4 d-flex align-items-center gap-3 ${fill ? 'flex-fill' : ''}`}
      style={{
        borderTop: active ? `2px solid ${AppColors.warning}` : 'none',
      }}
    >
      <div
        className="w-30px h-30px rounded-circle"
        style={{
          padding: '3px',
          backgroundColor: done
            ? AppColors.primary
            : active
              ? AppColors.warning
              : AppColors.gray[300],
        }}
      >
        <div
          className="rounded-circle d-flex flex-column justify-content-center align-items-center w-100 h-100"
          style={{
            backgroundColor: done ? AppColors.primary : 'white',
          }}
        >
          {done ? (
            <i className="fa-regular fa-check text-white" />
          ) : (
            <span
              style={UIHelper.buildFontStyle(
                '700',
                '16px',
                active ? AppColors.warning : AppColors.gray[300]
              )}
            >
              {step}
            </span>
          )}
        </div>
      </div>
      <div className="flex-fill d-flex flex-column">
        <span
          style={UIHelper.buildFontStyle(
            '700',
            '14px',
            active ? AppColors.warning : AppColors.gray[800]
          )}
        >
          {title}
        </span>
        <span
          style={UIHelper.buildFontStyle(
            '500',
            '10px',
            active ? AppColors.gray[800] : AppColors.gray[600]
          )}
        >
          {subTitle}
        </span>
      </div>
      <i
        className="fa-regular fa-chevron-right"
        style={{
          color: AppColors.gray[300],
        }}
      />
    </div>
  );
}

export default WizardStep;